import { httpServices } from '../../../../apis'
import type { PaginatedQueryRequest, QueryFnParams } from '../../../../types'
import type { RestCounterType } from '../../types/RestCounter'
import type {
  AccumulatorsUserContractBalanceSchema,
  AccumulatorsUserContractSchema
} from '../types'

/**
 * Fetch accumulators for a given user contract
 */
export type FetchMultiTypeAccumulatorsUserContractQueryParams = {
  types?: ('holiday' | 'rcr' | 'rtt')[]
}

export type FetchMultiTypeAccumulatorsUserContractOptions = QueryFnParams<{
  pathParams: {
    user_contract_id: number
  }
  queryParams: FetchMultiTypeAccumulatorsUserContractQueryParams
}>

export const fetchMultiTypeAccumulatorsUserContract = async (
  opts: FetchMultiTypeAccumulatorsUserContractOptions
) => {
  const response = await httpServices.core.get<
    AccumulatorsUserContractBalanceSchema[]
  >(`/user_contracts/${opts?.pathParams?.user_contract_id}/accumulators`, {
    params: opts?.queryParams
  })
  return response.data
}

/**
 * Fetch  accumulators for a given user contract
 */
export type FetchAccumulatorsUserContractQueryParams = PaginatedQueryRequest & {
  includes?: ('operations' | 'rests' | 'pay_periods')[]
  rest_id?: number
}

export type FetchAccumulatorsUserContractOptions = QueryFnParams<{
  pathParams: {
    user_contract_id: number
    type: RestCounterType
  }
  queryParams: FetchAccumulatorsUserContractQueryParams
}>

export const fetchAccumulatorsUserContract = async (
  opts: FetchAccumulatorsUserContractOptions
) => {
  const response = await httpServices.core.get<AccumulatorsUserContractSchema>(
    `/${opts.pathParams.type}/user_contracts/${opts.pathParams.user_contract_id}/accumulator`,
    {
      params: opts?.queryParams
    }
  )
  return response.data
}
